<template>
  <el-card class="box-card">
    <div class="main">
      <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
        <el-form-item>
          <el-select v-model="searchInfo.projectId" placeholder="请选择所属项目" filterable clearable>
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="vehicleName">
          <el-input v-model="searchInfo.teamName" size="small" placeholder="请输入班组名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="mb20">
        <el-button type="primary" icon="el-icon-plus" @click="onAdd" v-show="$ButtonShow('YTM_ADD_01')">新增</el-button>
      </div>
      <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData" max-height="550px">
        <el-table-column label="班组名称" min-width="80px" show-overflow-tooltip prop="teamName">
        </el-table-column>
        <el-table-column label="所属项目" min-width="80px" show-overflow-tooltip prop="projectName">
        </el-table-column>
        <el-table-column label="班组负责人" min-width="70px" show-overflow-tooltip prop="teamLeader">
        </el-table-column>
        <el-table-column label="负责人电话" min-width="60px" show-overflow-tooltip prop="teamLeaderPhone">
        </el-table-column>
        <el-table-column label="设备总数" min-width="100px" show-overflow-tooltip prop="deviceCount">
          <template v-slot="{ row }">
            {{row.deviceCount || 0}}
          </template>
        </el-table-column>
        <el-table-column label="设备总数" min-width="100px" show-overflow-tooltip>
          <template v-slot="{ row }">
            在线 {{row.onDeviceCount || 0}} / 离线 {{row.offDeviceCount || 0}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="360px" fixed="right">
          <template v-slot="{ row }">
            <el-button v-show="$ButtonShow('YHW_PLAY_01') && row.deviceCount > 0" type="text" @click="onPlay(row)">轨迹回放</el-button>
            <el-button v-show="$ButtonShow('YHW_Bind_01')" type="text" @click="onBind(row)">绑定/更换设备</el-button>
            <el-button type="text" @click="onDetail(row.teamId)">查看</el-button>
            <el-button type="text" @click="onEdit(row.teamId)" v-show="$ButtonShow('YTM_EDT_01')">编辑</el-button>
            <el-button type="text" @click="onForbidden(row.teamId, row.status)" v-show="$ButtonShow('YTM_EDT_02')">{{
              row.status === '1' ? '禁用' : '启用' }}</el-button>
            <el-button type="text" @click='onDelete(row.teamId)' v-show="$ButtonShow('YTM_DEL_02')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Add :addShow.sync="addShow" @success="loadData" :id.sync=id></Add>
      <Details :detailsShow.sync="detailsShow" :id.sync=detailId></Details>
      <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
        @size-change="loadData"></global-pagination>
      <Bind :dialogVisible.sync="isShowBind" :info="info" @success="success"></Bind>
    </div>
  </el-card>
</template>

<script>
import Add from './Add.vue'
import Details from './Details.vue'
import Bind from './Bind.vue'

export default {
  name: 'laborManageListTeams',
  components: { Add, Details, Bind },
  data () {
    return {
      searchInfo: {
        projectId: '',
        teamName: ''
      },
      addShow: false,
      detailsShow: false,
      id: '',
      detailId: '',
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      isShowBind: false,
      info: {}
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onSearch () {
      this.page = 1
      this.loadData()
    },

    loadData () {
      this.loading = true
      this.$axios.get(
        this.$apis.laborManage.selectYhTeamByPage,
        {
          ...this.searchInfo,
          page: this.page,
          size: this.size
        }
      ).then((res) => {
        if (res) {
          this.total = res.total || 0
          this.tableData = res.list || []
        }
      }).finally(() => {
        this.loading = false
      })
    },

    // 新增
    onAdd () {
      this.id = ''
      this.$nextTick(() => {
        this.addShow = true
      })
      // this.$router.push({ name: 'addTeams' })
    },

    // 编辑
    onEdit (id) {
      this.id = id
      this.addShow = true
    },

    // 查看
    onDetail (id) {
      this.detailId = id
      this.detailsShow = true
    },

    // 启用/禁用班组
    onForbidden (teamId, status) {
      let submitStatus = ''
      let description = ''
      if (status === '1') {
        submitStatus = '2'
        description = '禁用'
      } else {
        submitStatus = '1'
        description = '启用'
      }
      this.$confirm(`确认${description}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }) .then(() => {
        this.loading = true
        this.$axios.post(this.$apis.laborManage.forbiddenYhTeam, { teamId, status: submitStatus }).then(() => {
          this.$message.success('操作成功')
          this.loadData()
        }).finally(() => {
          this.loading = false
        })
      })
    },

    // 删除
    onDelete (teamId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$axios.post(this.$apis.laborManage.deleteDataYhTeam, { teamId }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        }).finally(() => {
          this.loading = false
        })
      })
    },
    onBind (row) {
      this.info = row
      this.isShowBind = true
    },
    onPlay (row) {
      this.$router.push({
        name: 'teamsPlay',
        params: {
          teamId: row.teamId,
          projectId: row.projectId
        }
      })
    },
    success () {
      this.info = {}
      this.onSearch()
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  padding: 0px 10px;
}

.button-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
</style>
